import { render, staticRenderFns } from "./slot-widget.vue?vue&type=template&id=6b6d51b0&scoped=true"
import script from "./slot-widget.vue?vue&type=script&lang=js"
export * from "./slot-widget.vue?vue&type=script&lang=js"
import style0 from "./slot-widget.vue?vue&type=style&index=0&id=6b6d51b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d51b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6d51b0')) {
      api.createRecord('6b6d51b0', component.options)
    } else {
      api.reload('6b6d51b0', component.options)
    }
    module.hot.accept("./slot-widget.vue?vue&type=template&id=6b6d51b0&scoped=true", function () {
      api.rerender('6b6d51b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/slot-widget.vue"
export default component.exports